import Vue from 'vue'
import Swal from 'sweetalert2'

//import 'sweetalert2/src/variables.scss'

// export default Object.defineProperty(Vue.prototype, '$sweet', {
//     value: Swal
// });

Vue.prototype.$sweet = Swal